export enum IncidentsDetailStatusEnum {
    WaitingForProcessing = 'Aguardando Processamento',
    Processing = 'Processando',
    Processed = 'Processado',
    Error = 'Erro'
  }